import { useEffect, useState } from "react";
import Select from "react-select";
import stockService from "../services/stock";
import constants from "../utils/constants";
import style from "../utils/style";
import useStore from "../store/store";

const StockDropDown = ({ label, placeholder, value, onChange }) => {
	let [options, setOptions] = useState([]);
	const [selectedValue, setSelectedValue] = useState({
		label: label,
		value: value,
	});

	useEffect(() => {
		getStocks();
	}, []);

	const { token, setErrorMessage, setIsLoading } = useStore((state) => state);

	const getStocks = () => {
		stockService.reload(token, "").then((r) => {
			if (r.error) {
				setErrorMessage(r.error);
				setIsLoading(false);
				return;
			}
			createOptions(r.data);
		});
	};

	const createOptions = (data) => {
		let arr = [];
		data.map((obj) => {
			let k = { value: obj._id, label: obj.title };
			arr.push(k);
		});
		setOptions(arr);
	};

	const styles = {
		control: (base, state) => ({
			...base,
			minHeight: 56,
			height: 56,
			border: state.isFocused
				? `2px solid ${constants.PRIMARY}`
				: "`2px solid grey`",
			boxShadow: "none",
			...style.marginY1,
		}),
		valueContainer: (base) => base,
		option: (base, { isSelected }) => ({
			...base,
			backgroundColor: isSelected ? constants.PRIMARY : "none",
		}),
		input: (base) => base,
		placeholder: (base) => base,
		singleValue: (base, { data }) => base,
		menuPortal: (base) => base,
		menu: (base) => ({ ...base, zIndex: 9 }),
	};

	return (
		<div className="input-control">
			<Select
				closeMenuOnSelect={true}
				options={options}
				placeholder={placeholder || label}
				label={label}
				components={{
					IndicatorSeparator: () => null,
				}}
				defaultValue={selectedValue}
				value={options.find((option) => option.value === value) || ""}
				onChange={(v) => {
					setSelectedValue(v);
					onChange(v);
				}}
				styles={styles}
			/>
		</div>
	);
};

export default StockDropDown;
